import * as React from 'react';

export class Omnibox extends React.Component<{}, {}> {
    public render(){
        // The following temporary code is just a placeholder.
        // It will be replaced later with actual code.
        return <div>New omnibox is coming...</div>;
    }
}